import { memo, useState } from 'react'
import { AdvancedTooltip, Icon, Text } from 'common-components'
import * as Styled from './styled'
import { IAIImageModel } from 'store/types/aiImage'
import ThunderIcon from 'assets/svgr-icons/Thunder.svg'
import CrownIcon from 'assets/svgr-icons/Crown.svg'
import { useSelector } from 'react-redux'
import { userSelectors } from 'store/features/user/selectors'
import { getDeviceVersion } from 'utils'

interface IImageModelItemProps {
  model: IAIImageModel
  isSelected: boolean
  onSelect: () => void
  isPremium?: boolean
}

const getModelCost = (
  model: IAIImageModel,
  unlimitedAiImageModelIds: number[]
) => {
  const isUnlimited = unlimitedAiImageModelIds?.some(id => id === model.id)
  if (isUnlimited) {
    return 0
  }
  return model.cost
}

const ImageModelItem: React.FC<IImageModelItemProps> = ({
  model,
  isSelected,
  onSelect,
  isPremium
}) => {
  const unlimitedAiImageModelIds = useSelector(
    userSelectors.unlimitedAiImageModelIds
  )
  const modelCost = getModelCost(model, unlimitedAiImageModelIds)
  const [imageModelItemRef, setImageModelItemRef] =
    useState<HTMLDivElement | null>(null)
  const isMobile = getDeviceVersion()
  return (
    <Styled.ModelItemWrapper
      $isSelected={isSelected}
      onClick={onSelect}
      ref={setImageModelItemRef}
    >
      <Styled.ModelTextContent>
        <Styled.ModelNameWrapper>
          <Text
            type="subtitle"
            color={isSelected ? 'secondaryDark' : 'secondarySemiDark'}
          >
            {model.name}
          </Text>
          <Styled.CreditsWrapper>
            <Icon icon={<ThunderIcon />} size="small" color="secondary" />
            <Text type="h4" color="secondary" fontWeight="600">
              {modelCost}
            </Text>
          </Styled.CreditsWrapper>
          {isPremium && (
            <Styled.CrownBadgeIcon
              icon={<CrownIcon />}
              size="small"
              color="goldDark"
            />
          )}
        </Styled.ModelNameWrapper>
        {model.description &&
          (isMobile ? (
            <Text type="h4" color="secondarySemiDark" lineHeight="1.3">
              {model.description}
            </Text>
          ) : (
            <AdvancedTooltip
              btnRef={{ current: imageModelItemRef }}
              tooltipText={model.description}
              tooltipPosition="right"
              maxWidth={300}
              textAlign="left"
            />
          ))}
      </Styled.ModelTextContent>
    </Styled.ModelItemWrapper>
  )
}

ImageModelItem.displayName = 'ImageModelItem'

export default memo(ImageModelItem)
